import React, { Suspense } from 'react';
import { Route, Switch } from 'react-router-dom';
import Loading from '@/shared/components/Loading';
import { paths } from '@/shared/helpers/paths';
import { SponsorshipPage } from './components/SponsorshipPage';

export const cadsAiSponsorshipBaseUrl = paths.CADS_AI.HOME.SPONSORSHIP;

const Sponsorship = () => {
  return (
    <Suspense fallback={<Loading />}>
      <Switch>
        <Route path={cadsAiSponsorshipBaseUrl} component={SponsorshipPage} />
      </Switch>
    </Suspense>
  );
};

export default Sponsorship;
